import React, { useEffect, useState } from 'react';

import clsx from 'clsx';
import VerifyEmail from './Components/VerifyEmail';

import styles from './styles.module.scss';
import VerifyOtp from './Components/VerifyOtp';
import SetPassword from './Components/SetPassword';
import { useLocation } from 'react-router-dom';
type ResetPasswordProps = {
  className?: string;
};

const ResetPassword: React.FunctionComponent<ResetPasswordProps> = ({
  className,
}) => {
  const classNames = clsx(styles.reset, className);
  const [activeTab, setActiveTab] = useState('');
  const [reSubmitEmail, setReSubmitEmail] = useState('');
  const [token, setToken] = useState('');
  const [email, setEmail] = useState('');
  const location = useLocation();

  useEffect(() => {
    if (location?.state !== undefined) {
      setActiveTab('VerifiedOtp');
    }
  }, [location?.state]);

  return (
    <div id={styles.myAxelosResetPassword} className={styles.container}>
      <div
        id="background_branding_container"
        className={styles.myAxelosIntro}
        data-tenant-branding-background-color="true"
      >
        <span className={styles.image}></span>
        <div>
          <h1>
            MyAxelos will soon be discontinued.
            <br />
            {/* <span>PeopleCert Plus</span> */}
          </h1>
          <p className={styles.pcLoginInfo}>
            <b>The Accredited Consulting Partner (ACP) Programme</b> has now
            transitioned to peoplecert.org. To continue accessing ACP resources,
            tools, and partner information, please log in{' '}
            <a href="https://login.peoplecert.org/?lg=1">here</a> using your
            existing credentials.
          </p>
          <p className={styles.pcLoginInfo}>
            All information related to certifications, exams, and professional
            learning resources is now available through{' '}
            <b>PeopleCert Membership.</b> Simply log in{' '}
            <a href="https://www.peoplecert.org/login">here</a> with your
            current credentials to access them.
          </p>
        </div>
        <span className={styles.backgroundSlice}></span>
      </div>
      <div className={styles.myAxelosForm} id="panel">
        <div className={styles.formContainer}>
          <div id="resetPasswordContent"></div>
          {activeTab === '' && (
            <VerifyEmail
              setActiveTab={setActiveTab}
              setReSubmitEmail={setReSubmitEmail}
              setToken={setToken}
              setEmail={setEmail}
            />
          )}
          {activeTab === 'VerifiedOtp' && (
            <VerifyOtp
              setActiveTab={setActiveTab}
              setEmail={setEmail}
              setToken={setToken}
              reSubmitEmail={reSubmitEmail}
            />
          )}
          {activeTab === 'setPassword' && (
            <SetPassword token={token} email={email} />
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
